(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ttn-directory-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ttn-team-directory')) {
  customElements.define('ttn-team-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.querySelector('.ttn-directory-search').hidden = false;
      const input = this.querySelector('[data-team-search]');
      input.addEventListener('input', () => {
        const term = input.value.trim().toLocaleLowerCase();
        let count = 0;
        this.querySelectorAll('[data-team-name]').forEach(card => {
          card.hidden = !card.dataset.teamName.toLocaleLowerCase().includes(term);
          if (!card.hidden) count++;
        });
        this.querySelector('[data-team-empty]').hidden = count !== 0;
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ttn-team-product-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ttn-team-personalization')) {
  customElements.define('ttn-team-personalization', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info') || this.closest('section');
      if (!this.root) return;
      this.nameInput = this.querySelector('[data-player-name]');
      this.numberInput = this.querySelector('[data-player-number]');
      this.sync = () => {
        const picker = this.root.querySelector('variant-selects');
        const groups = picker ? Array.from(picker.querySelectorAll('fieldset, select')) : [];
        const group = groups[Number(this.dataset.optionPosition) - 1];
        const value = group?.matches('select') ? group.selectedOptions[0]?.value : group?.querySelector('input:checked')?.value;
        const needsName = value === 'Player Name' || value === 'Name + Number';
        const needsNumber = value === 'Player Number' || value === 'Name + Number';
        [[this.nameInput, needsName, '[data-name-wrap]'], [this.numberInput, needsNumber, '[data-number-wrap]']].forEach(([input, active, wrap]) => {
          this.querySelector(wrap).hidden = !active;
          input.disabled = !active;
          input.required = active;
          if (!active) input.value = '';
        });
        this.querySelector('[data-personal-help]').hidden = !needsName && !needsNumber;
      };
      this.validate = event => {
        if (event.target.id !== this.dataset.formId) return;
        this.sync();
        for (const input of [this.nameInput, this.numberInput]) {
          if (input.disabled) continue;
          input.value = input.value.trim();
          if (!input.reportValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
        }
      };
      this.root.addEventListener('change', this.sync);
      this.root.addEventListener('submit', this.validate, true);
      this.observer = new MutationObserver(this.sync);
      const picker = this.root.querySelector('variant-selects');
      if (picker) this.observer.observe(picker, { childList: true, subtree: true });
      this.sync();
    }
    disconnectedCallback() {
      this.root?.removeEventListener('change', this.sync);
      this.root?.removeEventListener('submit', this.validate, true);
      this.observer?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
